import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy, CommonModule } from '@angular/common';
import { environment } from '../environments/environment';

import { AgmCoreModule } from '@agm/core';
import { SharedModule } from './shared/shared.module';
import { ToastrModule } from 'ngx-toastr';

import { AngularFireModule } from '@angular/fire';
import { AngularFireMessagingModule } from '@angular/fire/messaging';

/* Loader */
import { NgHttpLoaderModule } from 'ng-http-loader';

import { routing } from './app.routing';
import { AppSettings } from './app.settings';

/* Core */
import { NotFoundComponent } from './core/not-found/not-found.component';
import { UnauthorizedComponent } from './core/unauthorized/unauthorized.component';
import { WithoutPermissionComponent } from './core/without-permission/without-permission.component';
import { AuthenticationComponent } from './core/authentication/authentication.component';

import { I18n, CustomDatepickerI18n } from './shared/components/date-picker/date-picker.model';
import { NgbDatepickerI18n, NgbDateParserFormatter, NgbDateAdapter, NgbDateNativeAdapter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatePTParserFormatter } from './shared/components/date-picker/date-parser.model';

import { AuthGuard } from './auth-guard.service';
import { PendingChangesGuard } from './pending-changes-guard.service';
import { NavigationHistoryService } from './navigation-history.service';
import { HttpErrorHandler } from './http-error-handler.service';
import { httpInterceptorProviders } from './http-interceptors';
import { MessageService } from './shared/messages/message.service';
import { FirebaseCloudMessageService } from './firebase-cloud-message.service';

import { AppComponent } from './app.component';

import { UsuarioService } from './pages/usuario/usuario.service';
import { LoaderComponent } from './theme/loader/loader.component';
import { RouterModule } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';
import { EndpointLocationProviderService } from './shared/services/endpoint-location-provider.service';
//import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgFloatingActionMenuModule } from 'ng-floating-action-menu';


@NgModule({
  declarations: [
    AppComponent,
     NotFoundComponent,
    UnauthorizedComponent,
    WithoutPermissionComponent,
    AuthenticationComponent,
    LoaderComponent
  ],
  imports: [
    RouterModule.forRoot([]),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireMessagingModule,
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    CommonModule,
    NgHttpLoaderModule.forRoot(),
    NgFloatingActionMenuModule,
   // SweetAlert2Module.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDTlWRVmzua_yzh9m5iUbYkCJyv9ppjKrw',
      libraries: ['geometry']
    }),
    routing,
    ToastrModule.forRoot({
      closeButton: true,
      positionClass: 'toast-bottom-center',
      timeOut: 3000,
      extendedTimeOut: 3000,
      preventDuplicates: true,
      onActivateTick: true
    }),
    NgbModule,
    OverlayModule
  ],
  providers: [
    AppSettings,
    MessageService,
    FirebaseCloudMessageService,
    HttpErrorHandler,
    httpInterceptorProviders,
    AuthGuard,
    PendingChangesGuard,
    UsuarioService,
    NavigationHistoryService,
    Location,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }],
    [{ provide: NgbDateParserFormatter, useClass: NgbDatePTParserFormatter }],
    [{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }]
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent],
  entryComponents: [LoaderComponent]
})
export class AppModule {

  private env = environment;

  constructor(private endpointLocationService: EndpointLocationProviderService) {
    // Injeta o webcomponent na aplicação
    // const scriptTag = document
    //   .createElement('script');
    // scriptTag.setAttribute('src', `${this.endpointLocationService.getEndpointURI(this.env.WEBCOMPONENT_AGENDAMENTO)}/agendamento-webcomponent.js`);
    // scriptTag.setAttribute('type', 'text/javascript');

    // document.body.appendChild(scriptTag);
  }

}
